import React from 'react';
import { Button as MUIButton, ButtonProps as MUIButtonProps, styled } from '@mui/material';

export interface ButtonProps extends MUIButtonProps {
  /** Button text content */
  children: React.ReactNode;
  /** Full width button */
  fullWidth?: boolean;
  /** Icon to display before text */
  startIcon?: React.ReactNode;
  /** Icon to display after text */
  endIcon?: React.ReactNode;
}

const StyledButton = styled(MUIButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  padding: theme.spacing(1.5, 3),
  fontWeight: theme.typography.fontWeightMedium,
}));

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'contained',
  size = 'medium',
  fullWidth = false,
  startIcon,
  endIcon,
  color = 'primary',
  ...rest
}) => {
  return (
    <StyledButton
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      color={color}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
